enum StaticLinks {
  Guides = '//help.{env}enlil.io/',
  ReleaseNotes = '//help.{env}enlil.io/release_notes.html',
  FAQs = '//help.{env}enlil.io/faqs.html',
  Contact = '//shifamed.atlassian.net/servicedesk/customer/portals',
}

export default StaticLinks;
